function NotFound() {
  return (
    <div className="container">
      <div className="card">
        <h2>404 ❌</h2>
        <p>Oops! Page not found.</p>
      </div>
    </div>
  );
}

export default NotFound;